import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CENTERED_MODAL_LIST } from "../../../../Data/UiKit/Modal";
import { AlertMessage, CenteredModals, Close, SomethingWentWrong, VerticallyCentered } from "../../../../Constant";
import CommonModal from "../Common/CommonModal";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { Btn, H4, Image, LI, P, UL } from "../../../../AbstractElements";
import { useState } from "react";

const CenteredModal = () => {
  const [centerd, setCentered] = useState(false);
  const centeredToggle = () => setCentered(!centerd);
  return (
      <Col xl="4">
        <Card>
          <CommonCardHeader title={CenteredModals} span={CENTERED_MODAL_LIST} />
          <CardBody className="badge-spacing">
          <Btn color="success" type="button" onClick={centeredToggle}>{VerticallyCentered}</Btn>
            <CommonModal centered isOpen={centerd} toggle={centeredToggle}>
              <div className="modal-toggle-wrapper">
                <UL className="modal-img simple-list">
                  <LI className="text-center"><Image src={dynamicImage("gif/danger.gif")} alt="error" /></LI>
                </UL>
                <H4 className="text-center pb-2">{SomethingWentWrong}</H4>
                <P className="text-center">{AlertMessage}</P>
                <Btn color="secondary" className="d-flex m-auto" type="button" onClick={centeredToggle}>{Close}</Btn>
              </div>
            </CommonModal>
          </CardBody>
        </Card>
      </Col>
  );
};

export default CenteredModal;
